import axios from 'axios';
import BaseApi from './base';
import {
    LANGUAGES,
} from '../constants/api';

const BASIC_TOKEN = process.env.VUE_APP_BASIC_TOKEN;

export default class extends BaseApi {
    static get() {
        return axios.get(LANGUAGES, {
            headers: {
                'Authorization': `Basic ${BASIC_TOKEN}`,
            },
        });
    }
}